import useFoodCost from './useFoodCost'
import useGuest from './useGuest'
import useLabor from './useLabor'

export type IAiSummaryType = 'ghaiPopFoodCost' | 'ghaiPopLabor' | 'ghaiPopGuest'

export const hooks = [
  ['ghaiPopFoodCost', useFoodCost],
  ['ghaiPopLabor', useLabor],
  ['ghaiPopGuest', useGuest],
] as const
